export const RTB_TIMEZONE = 'Asia/Aqtau';

const weekdayIndex = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };

const weekSlotFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: RTB_TIMEZONE,
    weekday: 'short',
    hour: '2-digit',
    hourCycle: 'h23',
});

/** Индекс дня с понедельника (0–6) и час 0–23 в поясе RTB. */
export function rtbWeekSlot(date = new Date()) {
    const parts = weekSlotFormatter.formatToParts(date);
    const weekday = parts.find((part) => part.type === 'weekday')?.value;
    const hour = Number(parts.find((part) => part.type === 'hour')?.value);

    return {
        day: weekdayIndex[weekday] ?? 0,
        hour: Number.isInteger(hour) ? hour % 24 : 0,
    };
}

export function formatInRtbTZ(dateInput) {
    if (!dateInput) return '—';
    const d = (typeof dateInput === 'number' || typeof dateInput === 'string') ? new Date(dateInput) : dateInput;
    if (!d || isNaN(d.getTime())) return '—';
    return new Intl.DateTimeFormat('ru-RU', {
        timeZone: RTB_TIMEZONE,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(d);
}

const shortDateTimeFormatter = new Intl.DateTimeFormat('ru-RU', {
    timeZone: RTB_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
});

/** «05.10.2026, 14:32» в часовом поясе RTB — для таблиц. */
export function formatShortDateTimeInRtbTZ(dateInput) {
    if (!dateInput) return '—';
    const d = new Date(dateInput);
    return isNaN(d.getTime()) ? '—' : shortDateTimeFormatter.format(d);
}

export function formatTimestampMsInRtbTZ(ms) {
    if (ms === null || ms === undefined) return '—';
    const t = typeof ms === 'number' ? ms : parseInt(ms, 10);
    if (Number.isNaN(t)) return '—';
    return formatInRtbTZ(new Date(t));
}

export function formatDateOnlyInRtbTZ(dateInput) {
    if (!dateInput) return '—';
    const d = (typeof dateInput === 'number' || typeof dateInput === 'string') ? new Date(dateInput) : dateInput;
    if (!d || isNaN(d.getTime())) return '—';
    const opts = { timeZone: RTB_TIMEZONE };
    const dd = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', ...opts }).format(d);
    return dd.replace(/\//g, '.'); // convert 31/03/2026 -> 31.03.2026
}

export function getRtbDateString(date = new Date()) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: RTB_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}

export function getDefaultRtbFilterRange() {
    const today = getRtbDateString();
    return {
        start_date: `${today}T00:00:00`,
        end_date: `${today}T23:59:59`,
    };
}

export function rtbFilterToApiDatetime(value) {
    if (!value) return '';
    const normalized = String(value).trim().replace('T', ' ');
    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
        return normalized;
    }
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(normalized)) {
        return `${normalized}:00`;
    }
    return normalized.slice(0, 19);
}

